const { Keycloak } = require('@bitsbeats/bb-horus-frontend');

const EmbeddedKeycloak = window.Keycloak;

module.exports = new Keycloak(EmbeddedKeycloak, {
    url: window._ENV.REACT_APP_AUTH_URL,
    realm: window._ENV.REACT_APP_REALM,
    clientId: window._ENV.REACT_APP_CLIENT_ID,
});
